(function () {
  if (window.QLSMobileCollectionFloatingFilterButtonV8Loaded) return;
  window.QLSMobileCollectionFloatingFilterButtonV8Loaded = true;

  window.QLSMobileCollectionFloatingFilterButtonV1Loaded = true;
  window.QLSMobileCollectionFloatingFilterButtonV2Loaded = true;
  window.QLSMobileCollectionFloatingFilterButtonV3Loaded = true;
  window.QLSMobileCollectionFloatingFilterButtonV4Loaded = true;
  window.QLSMobileCollectionFloatingFilterButtonV5Loaded = true;
  window.QLSMobileCollectionFloatingFilterButtonV6Loaded = true;
  window.QLSMobileCollectionFloatingFilterButtonV7Loaded = true;

  var root = document.documentElement;
  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
  var dock = null;
  var syncTimer = null;
  var cachedGrid = null;
  var gridCacheTime = 0;

  function isMobile() {
    return mobileQuery ? mobileQuery.matches : window.innerWidth <= 768;
  }

  function isCollectionPage() {
    var bodyClass = document.body ? String(document.body.className || '').toLowerCase() : '';
    var path = String(window.location.pathname || '').toLowerCase();

    return (
      bodyClass.indexOf('template-collection') !== -1 ||
      path.indexOf('/collections/') !== -1
    );
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hasWord(text, word) {
    return new RegExp('(^|[^a-z0-9])' + word + '([^a-z0-9]|$)', 'i').test(text || '');
  }

  function isUsableElement(el) {
    if (!el || !el.getBoundingClientRect) return false;
    if (el.disabled) return false;
    if (el.closest && el.closest('.qls-collection-action-dock, .qls-floating-filter-button')) return false;

    var style = window.getComputedStyle(el);

    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      style.pointerEvents === 'none'
    ) {
      return false;
    }

    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isVisibleElement(el) {
    if (!el || !el.getBoundingClientRect) return false;

    var style = window.getComputedStyle(el);

    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      style.opacity === '0'
    ) {
      return false;
    }

    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isBadArea(el) {
    if (!el || !el.closest) return true;

    return !!el.closest([
      'header',
      'store-header',
      '.header',
      '.section-header',
      '.shopify-section-header',
      'cart-drawer',
      '#cart-drawer',
      '#CartDrawer',
      '.cart-drawer',
      '.drawer--cart',
      '.menu-drawer',
      '#menu-drawer',
      '#MenuDrawer',
      'predictive-search',
      '.predictive-search',
      'footer'
    ].join(','));
  }

  function textLooksLikeFilter(el) {
    if (!el) return false;

    var combined = normalize([
      el.textContent,
      el.getAttribute('aria-label'),
      el.getAttribute('name'),
      el.getAttribute('id'),
      el.getAttribute('class'),
      el.getAttribute('data-action'),
      el.getAttribute('data-drawer'),
      el.getAttribute('aria-controls')
    ].join(' '));

    return (
      combined.indexOf('filter') !== -1 ||
      combined.indexOf('filters') !== -1 ||
      combined.indexOf('refine') !== -1 ||
      combined.indexOf('facet') !== -1
    );
  }

  function findExistingFilterTrigger() {
    if (!document.body) return null;

    var selectors = [
      'main button[aria-controls*="filter" i]',
      'main button[aria-controls*="facet" i]',
      'main button[aria-label*="filter" i]',
      'main button[aria-label*="refine" i]',
      'main summary[aria-controls*="filter" i]',
      'main summary[aria-controls*="facet" i]',
      'main [data-filter-drawer-trigger]',
      'main [data-facets-drawer-toggle]',
      'main [data-filters-toggle]',
      'main [data-filter-toggle]',
      'main [data-action*="filter" i]',
      'main .facets__open',
      'main .mobile-facets__open',
      'main .js-show-filters',
      'main .filter-toggle',
      'main .filters-toggle',
      'main .collection-filter__button',
      'main .collection-filters__button',
      'main .product-filters__button'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);

      for (var j = 0; j < nodes.length; j++) {
        if (!isBadArea(nodes[j]) && isUsableElement(nodes[j])) {
          return nodes[j];
        }
      }
    }

    var candidates = document.querySelectorAll('main button, main summary');

    for (var k = 0; k < candidates.length; k++) {
      var candidate = candidates[k];

      if (
        !isBadArea(candidate) &&
        isUsableElement(candidate) &&
        textLooksLikeFilter(candidate)
      ) {
        return candidate;
      }
    }

    return null;
  }

  function countProductLinks(el) {
    if (!el) return 0;

    var links = el.querySelectorAll('a[href*="/products/"]');
    var unique = {};

    links.forEach(function (link) {
      var href = String(link.getAttribute('href') || '').split('?')[0];

      if (href.indexOf('/products/') !== -1) {
        unique[href] = true;
      }
    });

    return Object.keys(unique).length;
  }

  function looksLikeProductGrid(el) {
    if (!el || !isVisibleElement(el)) return false;
    if (isBadArea(el)) return false;

    var productLinkCount = countProductLinks(el);
    if (productLinkCount >= 2) return true;

    var productCardCount = el.querySelectorAll([
      '.product-card',
      '.card-wrapper',
      '.product-item',
      '.grid__item',
      '[data-product-id]',
      'product-card'
    ].join(',')).length;

    return productCardCount >= 2;
  }

  function findProductGridArea() {
    if (
      cachedGrid &&
      document.body &&
      document.body.contains(cachedGrid) &&
      Date.now() - gridCacheTime < 1200
    ) {
      return cachedGrid;
    }

    var selectors = [
      '#ProductGridContainer',
      '#product-grid',
      '.product-grid',
      '.collection__products',
      '.collection-products',
      '.collection-product-grid',
      '.main-products-grid',
      '.product-list',
      '.product-list-container',
      '.products-grid',
      '.grid.product-grid',
      '[data-product-grid]',
      '[data-collection-products]',
      'ul[id*="product-grid" i]',
      'div[id*="product-grid" i]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);

      for (var j = 0; j < nodes.length; j++) {
        if (looksLikeProductGrid(nodes[j])) {
          cachedGrid = nodes[j];
          gridCacheTime = Date.now();
          return cachedGrid;
        }
      }
    }

    var firstProductLink = document.querySelector('main a[href*="/products/"]');

    if (firstProductLink) {
      var parent = firstProductLink.closest([
        '#ProductGridContainer',
        '#product-grid',
        '.product-grid',
        '.collection__products',
        '.collection-products',
        '.collection-product-grid',
        '.main-products-grid',
        '.product-list',
        '.products-grid',
        '.grid',
        'ul',
        '.section',
        '.container'
      ].join(','));

      if (parent && looksLikeProductGrid(parent)) {
        cachedGrid = parent;
        gridCacheTime = Date.now();
        return cachedGrid;
      }
    }

    cachedGrid = null;
    gridCacheTime = Date.now();
    return null;
  }

  function isProductGridInView() {
    var grid = findProductGridArea();
    if (!grid) return false;

    var rect = grid.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    var gridHasStarted = rect.top < viewportHeight - 180;
    var gridHasNotEnded = rect.bottom > 180;

    return gridHasStarted && gridHasNotEnded;
  }

  function createDock() {
    if (dock && document.body.contains(dock)) return dock;
    if (!document.body) return null;

    document.querySelectorAll('.qls-floating-filter-button, .qls-collection-back-to-top, .qls-compare-exit-button').forEach(function (oldButton) {
      oldButton.remove();
    });

    dock = document.querySelector('.qls-collection-action-dock');

    if (dock && document.body.contains(dock)) {
      return dock;
    }

    dock = document.createElement('div');
    dock.className = 'qls-collection-action-dock';
    dock.setAttribute('role', 'group');
    dock.setAttribute('aria-label', 'Collection quick actions');

    dock.innerHTML =
      '<button type="button" class="qls-collection-action-dock__button qls-collection-action-dock__button--filter" aria-label="Open filters and sort options">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path d="M4 7h16M7 12h10M10 17h4" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>' +
        '</svg>' +
        '<span>Filter &amp; Sort</span>' +
      '</button>' +
      '<button type="button" class="qls-collection-action-dock__button qls-collection-action-dock__button--top" aria-label="Back to top">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path d="M6 7h12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>' +
          '<path d="M12 17V9" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>' +
          '<path d="m8.5 12.5 3.5-3.5 3.5 3.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        '<span class="qls-collection-action-dock__top-label">Back to top</span>' +
      '</button>';

    dock.querySelector('.qls-collection-action-dock__button--filter').addEventListener('click', function () {
      var trigger = findExistingFilterTrigger();

      if (!trigger) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      root.classList.add('qls-filter-button-busy');

      window.setTimeout(function () {
        root.classList.remove('qls-filter-button-busy');
      }, 700);

      trigger.click();
    });

    dock.querySelector('.qls-collection-action-dock__button--top').addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    document.body.appendChild(dock);
    return dock;
  }

  function getCompareCount() {
    var counter = document.querySelector('.js-compare-counter');
    var counterNumber = counter ? parseInt(String(counter.textContent || '').replace(/[^0-9]/g, ''), 10) : 0;

    if (!Number.isFinite(counterNumber)) counterNumber = 0;

    var checkedCount = document.querySelectorAll([
      '.js-compare-checkbox:checked',
      'input[type="checkbox"][name*="compare" i]:checked',
      'input[type="checkbox"][id*="compare" i]:checked',
      'input[type="checkbox"][class*="compare" i]:checked'
    ].join(',')).length;

    return Math.max(counterNumber, checkedCount);
  }

  function findSafeCompareModeToggle() {
    var candidates = document.querySelectorAll([
      'main input[type="checkbox"][id*="compare" i]:not(.js-compare-checkbox)',
      'main input[type="checkbox"][name*="compare" i]:not(.js-compare-checkbox)',
      'main [role="switch"][aria-label*="compare" i]',
      'main [role="switch"][id*="compare" i]',
      'main [role="switch"][class*="compare" i]'
    ].join(','));

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!el || !el.closest) continue;
      if (el.closest('.product-card, .card, product-card, .qls-collection-action-dock')) continue;
      if (!isUsableElement(el)) continue;

      var text = normalize([
        el.textContent,
        el.getAttribute('aria-label'),
        el.getAttribute('id'),
        el.getAttribute('class'),
        el.getAttribute('name')
      ].join(' '));

      if (text.indexOf('compare') !== -1) {
        return el;
      }
    }

    return null;
  }

  function exitCompareMode() {
    var selected = document.querySelectorAll([
      '.js-compare-checkbox:checked',
      'input[type="checkbox"][name*="compare" i]:checked',
      'input[type="checkbox"][id*="compare" i]:checked',
      'input[type="checkbox"][class*="compare" i]:checked'
    ].join(','));

    selected.forEach(function (checkbox) {
      if (!checkbox.disabled && checkbox.closest && checkbox.closest('.product-card, .card, product-card')) {
        checkbox.click();
      }
    });

    window.setTimeout(function () {
      var toggle = findSafeCompareModeToggle();

      if (toggle) {
        var isOn =
          toggle.checked === true ||
          toggle.getAttribute('aria-checked') === 'true' ||
          toggle.getAttribute('aria-pressed') === 'true' ||
          toggle.classList.contains('is-active') ||
          toggle.classList.contains('active');

        if (isOn) {
          try {
            toggle.click();
          } catch (e) {}
        }
      }
    }, 120);

    window.setTimeout(syncCompareState, 150);
    window.setTimeout(syncCompareState, 500);
    window.setTimeout(syncButton, 520);
  }

  function ensureCompareCloseButton() {
    var compareButton = document.querySelector('#compare-drawer-open');
    if (!compareButton) return;

    var closeButton = compareButton.querySelector('.qls-compare-inline-close');

    if (!closeButton) {
      closeButton = document.createElement('span');
      closeButton.className = 'qls-compare-inline-close';
      closeButton.setAttribute('role', 'button');
      closeButton.setAttribute('tabindex', '0');
      closeButton.setAttribute('aria-label', 'Exit compare mode');
      closeButton.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round"/>' +
        '</svg>';

      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }

        exitCompareMode();
      }, true);

      closeButton.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        event.stopPropagation();
        exitCompareMode();
      }, true);

      compareButton.appendChild(closeButton);
    }
  }

  function syncCompareState() {
    if (!isMobile() || !isCollectionPage()) {
      root.classList.remove('qls-compare-has-multiple');
      return;
    }

    var count = getCompareCount();
    var hasMultiple = count > 1;

    root.classList.toggle('qls-compare-has-multiple', hasMultiple);

    if (hasMultiple) {
      ensureCompareCloseButton();
    }
  }

  function shouldShowDock() {
    if (!isMobile() || !isCollectionPage()) return false;
    if (getCompareCount() > 1) return false;

    var hasScrolledEnough = (window.scrollY || window.pageYOffset || 0) > 220;

    return hasScrolledEnough && isProductGridInView();
  }

  function syncTopButtonState() {
    root.classList.toggle(
      'qls-collection-show-top',
      isMobile() && isCollectionPage() && (window.scrollY || window.pageYOffset || 0) > 640
    );
  }

  function syncButton() {
    window.clearTimeout(syncTimer);

    syncCompareState();
    syncTopButtonState();

    if (!isMobile() || !isCollectionPage()) {
      root.classList.remove('qls-floating-filter-ready');
      root.classList.remove('qls-floating-filter-visible');
      root.classList.remove('qls-collection-show-top');
      return;
    }

    createDock();

    root.classList.add('qls-floating-filter-ready');
    root.classList.toggle('qls-floating-filter-visible', shouldShowDock());
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncButton, 80);
  }

  // List/grid state is now owned exclusively by products-toolbar.js.

  document.addEventListener('scroll', scheduleSync, { passive: true });

  document.addEventListener('change', function () {
    window.setTimeout(syncCompareState, 50);
    window.setTimeout(syncButton, 120);
  }, true);

  document.addEventListener('click', function () {
    window.setTimeout(syncCompareState, 50);
    window.setTimeout(syncButton, 120);
    window.setTimeout(syncButton, 420);
  }, true);

  window.addEventListener('resize', function () {
    cachedGrid = null;
    scheduleSync();
  }, { passive: true });

  window.addEventListener('orientationchange', function () {
    cachedGrid = null;
    window.setTimeout(syncButton, 250);
  }, { passive: true });

  document.addEventListener('shopify:section:load', function () {
    cachedGrid = null;
    window.setTimeout(syncButton, 150);
  });

  if (mobileQuery && mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', syncButton);
  } else if (mobileQuery && mobileQuery.addListener) {
    mobileQuery.addListener(syncButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(syncButton, 100);
      window.setTimeout(syncButton, 800);
    });
  } else {
    window.setTimeout(syncButton, 100);
    window.setTimeout(syncButton, 800);
  }
})();
